import { OrderBookType } from '../../config/constants';

type AlterPositionOrders = Extract<
    OrderBookType,
    | OrderBookType.EXTEND_LEVERAGE
    | OrderBookType.ADD_MARGIN
    | OrderBookType.REMOVE_MARGIN
    | OrderBookType.EXTEND
    | OrderBookType.PARTIALLY_CLOSE
>;

const isAlterPositionOrder = (
    orderType: OrderBookType
): orderType is AlterPositionOrders => {
    return [
        OrderBookType.EXTEND_LEVERAGE,
        OrderBookType.ADD_MARGIN,
        OrderBookType.REMOVE_MARGIN,
        OrderBookType.EXTEND,
        OrderBookType.PARTIALLY_CLOSE,
    ].includes(orderType);
};

export default isAlterPositionOrder;
